// extracted by mini-css-extract-plugin
export default {"rodapeConfiguracoes":"Rodape_rodapeConfiguracoes__+dP8F","botao":"Rodape_botao__PON1m"};